"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.lenderSchema = exports.lenderAddressSchema = exports.claimPayeeSchema = exports.authorizedOfficerSchema = void 0;
var constants_1 = require("@hobt/constants");
var constants_2 = require("../../constants");
exports.authorizedOfficerSchema = {
    type: 'object',
    required: ['email', 'firstName', 'lastName', 'phoneNumber', 'position'],
    properties: {
        email: {
            type: 'string',
            minLength: 1,
            maxLength: 80,
            errorMessage: 'Should be a string with a maximum of 80 characters',
        },
        extension: {
            type: ['string', 'null'],
            minLength: 0,
            maxLength: 5,
            errorMessage: 'Should be a string with 5 characters or null',
        },
        faxNumber: {
            type: ['string', 'null'],
            minLength: 0,
            maxLength: 10,
            errorMessage: 'Should be a string with 10 characters or null',
        },
        firstName: {
            type: 'string',
            minLength: 1,
            maxLength: 15,
            errorMessage: 'Should be a string with a maximum of 15 characters',
        },
        lastName: {
            type: 'string',
            minLength: 1,
            maxLength: 25,
            errorMessage: 'Should be a string with a maximum of 25 characters',
        },
        phoneNumber: {
            type: 'string',
            minLength: 10,
            maxLength: 10,
            errorMessage: 'Should be a string with 10 characters',
        },
        position: {
            type: 'number',
            enum: Object.values(constants_2.AuthorizedOfficerPosition),
            errorMessage: 'Should equate to a valid AuthorizedOfficerPosition Enum value',
        },
    },
};
exports.claimPayeeSchema = {
    type: 'object',
    required: ['transitNumber', 'typeCode'],
    properties: {
        name: {
            type: ['string', 'null'],
            minLength: 0,
            maxLength: 35,
            errorMessage: 'Should be a string with a maximum of 35 characters or null',
        },
        transitNumber: {
            type: 'string',
            minLength: 5,
            maxLength: 5,
            errorMessage: 'Should be a string with 5 characters',
        },
        typeCode: {
            type: 'number',
            enum: Object.values(constants_2.ClaimPayeeType),
            errorMessage: 'Should equate to a valid ClaimPayeeType Enum value',
        },
    },
};
exports.lenderAddressSchema = {
    type: 'object',
    required: ['lineOne', 'municipalityName', 'postalCode', 'provinceCode'],
    properties: {
        lineOne: {
            type: 'string',
            minLength: 1,
            maxLength: 90,
            errorMessage: 'Should be a string with a maximum of 90 characters',
        },
        lineTwo: {
            type: ['string', 'null'],
            minLength: 0,
            maxLength: 90,
            errorMessage: 'Should be a string with a maximum of 90 characters or null',
        },
        municipalityName: {
            type: 'string',
            minLength: 1,
            maxLength: 20,
            errorMessage: 'Should be a string with a maximum of 20 characters',
        },
        postalCode: {
            type: 'string',
            minLength: 6,
            maxLength: 6,
            errorMessage: 'Should be a string with 6 characters',
        },
        provinceCode: {
            type: 'string',
            enum: Object.values(constants_1.StatisticsCanadaProvinceID),
            errorMessage: 'Should equate to a valid StatisticsCanadaProvinceID Enum value',
        },
    },
};
exports.lenderSchema = {
    type: 'object',
    required: [
        'address',
        'approvedLenderCode',
        'approvedLenderName',
        'authorizedOfficer',
        'claimPayee',
        'correspondenceLanguage',
    ],
    properties: {
        address: exports.lenderAddressSchema,
        approvedLenderCode: {
            type: 'string',
            minLength: 5,
            maxLength: 5,
            errorMessage: 'Should be a string with 5 characters',
        },
        approvedLenderName: {
            type: 'string',
            minLength: 1,
            maxLength: 35,
            errorMessage: 'Should be a string with a maximum of 35 characters',
        },
        authorizedOfficer: {
            type: 'array',
            items: exports.authorizedOfficerSchema,
            errorMessage: 'Should be a valid authorizedOfficer array',
        },
        claimPayee: exports.claimPayeeSchema,
        correspondenceLanguage: {
            type: 'number',
            enum: Object.values(constants_1.Language),
            errorMessage: 'Should equate to a valid Language Enum value',
        },
    },
};
